import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { CLEARING_DOC_API } from "./apiRoutes";

interface UseGetClearingDocListProps {
  communityId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClearingDocList = async (communityId: string, data: any) =>
  await axiosAuth.post(`${CLEARING_DOC_API(communityId)}/grid`, data);

const useGetClearingDocList = ({
  communityId,
  data,
  queryParams,
}: UseGetClearingDocListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["clearing-documents", communityId],
    queryFn: () => getClearingDocList(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetClearingDocList;
